/**
 * Motion helpers of the tool UI. The durations live in CSS (`--dur-*` in
 * kit-next.css); JS that has to wait for or drive an animation reads them from
 * here so there is one source of truth.
 */

/**
 * A kit duration token in milliseconds. 0 when the token is missing (outside
 * the kit scope, tests) or when reduced motion zeroed it, so "0" means "do not
 * animate".
 */
export function cssDurationMs(token: '--dur-1' | '--dur-2' | '--dur-3' | '--dur-chart' | '--dur-chart-update'): number {
  if (typeof document === 'undefined') return 0;
  const raw = getComputedStyle(document.documentElement).getPropertyValue(token).trim();
  const value = Number.parseFloat(raw);
  if (!Number.isFinite(value)) return 0;
  return raw.endsWith('ms') ? value : raw.endsWith('s') ? value * 1000 : 0;
}

export function prefersReducedMotion(): boolean {
  return typeof window !== 'undefined' && typeof window.matchMedia === 'function' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

/** A kit easing token (`--ease-out`) as a CSS timing function for `Element.animate`. */
export function cssEasing(token: '--ease-out' | '--ease-in'): string {
  if (typeof document === 'undefined') return 'ease';
  return getComputedStyle(document.documentElement).getPropertyValue(token).trim() || 'ease';
}
